import {SET_DELIVERY_ADDRESS_ACTION} from '../../../actionType';

export default function (state = {districtCity: undefined,
    countyMunicipality: undefined,
    subCountyTownCouncilDivision: undefined,
    parish: undefined,
    villageLocalCouncilZone: undefined,}, action) {
    switch (action.type) {
        case SET_DELIVERY_ADDRESS_ACTION:
            return {
                ...state,
                districtCity:action.districtCity,
                countyMunicipality:action.countyMunicipality,
                subCountyTownCouncilDivision:action.subCountyTownCouncilDivision,
                parish: action.parish,
                villageLocalCouncilZone:action.villageLocalCouncilZone,
            };
        default:
            return state;
    }
}
